'use client';

import { LiveChatWidget } from '@livechat/widget-react';
import useGeolocation from '@/hooks/useGeolocation';
import ErrorBoundary from '@/components/ErrorBoundary';
import { sendAppierEvent } from '@/utils/appier';

/**
 *
 * @param {*} props
 * @param {string} props.customerName
 * @param {string} props.customerEmail
 * @param {string} props.license
 * @param {string} props.phone
 * @returns
 */
export default function LiveChatProvider(props) {
  const { coords } = useGeolocation();

  return (
    <ErrorBoundary>
      <LiveChatWidget
        // livechat 群組
        group="7"
        license={props.license}
        visibility="minimized"
        customerName={props.customerName || '會員'}
        customerEmail={props.customerEmail || '無資料'}
        sessionVariables={{
          ...coords,
          phone: props.phone,
          name: props.customerName,
          email: props.customerEmail,
        }}
        onVisibilityChanged={(data) => {
          switch (data.visibility) {
            case 'maximized':
              // Appier Event Click_helper 聯繫客服
              sendAppierEvent('Click_helper', {
                user_id: props.userId || '未登入',
                phoneNo: props.phone || '未登入',
                user_name: props.customerName || '未提供',
                page_name: window?.top?.location?.pathname,
              });
              break;
            case 'minimized':
              break;
            case 'hidden':
              break;
          }
        }}
      />
    </ErrorBoundary>
  );
}
